@if ((isLoading$ | async) === false) {
  @if (representativeExample$ | async; as representativeExample) {
    {{ representativeExample }}
  }
} @else {
  <p-skeleton class="name" height="7rem" width="100%" />
}
